/**
 * @author EdenCha <eden@nurigo.net>
 */
import React, { useState } from 'react'
import classNames from 'classnames'
import { NavLink } from 'react-router-dom'
import withStyles from '@material-ui/core/styles/withStyles'

import Fade from '@material-ui/core/Fade'
import Divider from '@material-ui/core/Divider'
import Hidden from '@material-ui/core/Hidden'
import List from '@material-ui/core/List'
import ListItem from '@material-ui/core/ListItem'
import ListItemIcon from '@material-ui/core/ListItemIcon'
import ListItemText from '@material-ui/core/ListItemText'
import ListSubheader from '@material-ui/core/ListSubheader'
import Icon from '@material-ui/core/Icon'
import Grid from '@material-ui/core/Grid'
import Typography from '@material-ui/core/Typography'
import IconButton from '@material-ui/core/IconButton'
import Tooltip from '@material-ui/core/Tooltip'

import { RxOpenInNewWindow as RxOpenInNewWindowIcon } from 'react-icons/rx'
import {
  FaRegStar as FaRegStarIcon,
  FaStar as FaStarIcon
} from 'react-icons/fa'

import { isArray } from 'lib/detectType'

import LogoImg from 'static/image/logo.png'
import config from 'config'

const styles = theme => ({
  toolbar: Object.assign({}, theme.mixins.toolbar, {
    width: '100%',
    boxSizing: 'border-box',
    padding: 10
  }),
  toolbarLogoArea: {
    textAlign: 'center'
  },
  logoImg: {
    width: '70%',
    padding: '1em 0 1em 0'
  },
  listSubheader: {
    lineHeight: '30px'
  },
  listItem: {
    paddingTop: 2,
    paddingBottom: 2
  },
  listItemTextRoot: {
    padding: 0
  },
  listTextPrimaryRoot: {
    '&&': {
      fontWeight: 300
    }
  },
  adminTextColor: {
    color: '#0c5eba'
  },
  menuLink: {
    outline: 'none',
    color: theme.palette.text.primary,
    fill: theme.palette.text.secondary,
    display: 'block',
    textDecoration: 'none'
  },
  icon: {
    fontSize: '1.2rem'
  },
  listItemIcon: {
    minWidth: 0,
    marginRight: 10
  },
  selectedMenu: {
    backgroundColor: '#eee'
  },
  favoriteIcon: {
    fontSize: '0.9em',
    color: '#ffaf00'
  },
  favoriteRegIcon: {
    color: '#c5c5c5'
  },
  newTabIcon: {
    fontSize: '1em',
    verticalAlign: 'middle',
    marginLeft: 4
  },
  betaText: {
    color: '#fff',
    fontSize: '0.7em',
    marginLeft: 4,
    // padding: 2,
    paddingLeft: 4,
    paddingRight: 4,
    fontWeight: 'bolder',
    borderRadius: 5,
    // verticalAlign: 'top',
    backgroundColor: '#333'
  }
})

const LocalMenu = props => {
  const {
    classes,
    name,
    icon,
    fullLink,
    link,
    exact = true,
    admin,
    divider,
    isBeta,
    isFavorite,
    onClickFavoriteIcon
  } = props
  const [isHover, setHover] = useState(false)
  const menuExact =
    Object.prototype.toString.call(exact) === '[object String]'
      ? !new RegExp(exact).test(window.location.pathname)
      : exact
  return (
    <NavLink
      exact={menuExact}
      to={fullLink || link}
      className={classes.menuLink}
      activeClassName={classes.selectedMenu}
      onMouseEnter={() => {
        setHover(true)
      }}
      onMouseLeave={() => {
        setHover(false)
      }}
    >
      <ListItem divider={divider} button className={classes.listItem}>
        <ListItemIcon classes={{ root: classes.listItemIcon }}>
          <Icon
            className={classNames({
              [classes.icon]: true,
              [classes.adminTextColor]: admin === true
            })}
          >
            {icon}
          </Icon>
        </ListItemIcon>
        <ListItemText
          classes={{
            root: classes.listItemTextRoot
          }}
          primaryTypographyProps={{
            variant: 'body2',
            classes: {
              root: classNames({
                [classes.listTextPrimaryRoot]: true,
                [classes.adminTextColor]: admin === true
              })
            }
          }}
          primary={
            <Grid container wrap="nowrap" alignItems="center">
              <Grid item xs>
                <Typography variant="body2">
                  {name}
                  {isBeta === true && (
                    <Typography variant="caption" className={classes.betaText}>
                      BETA
                    </Typography>
                  )}
                </Typography>
              </Grid>
              <Grid item xs="auto">
                <Fade in={isHover === true || isFavorite === true}>
                  <Tooltip
                    title={isFavorite ? '즐겨찾기 해제' : '즐겨찾기 등록'}
                  >
                    <IconButton
                      size="small"
                      onClick={event =>
                        onClickFavoriteIcon(event, isFavorite, { name, link })
                      }
                    >
                      {!isFavorite ? (
                        <FaRegStarIcon
                          className={classNames(classes.favoriteIcon, {
                            [classes.favoriteRegIcon]: !isFavorite
                          })}
                        />
                      ) : (
                        <FaStarIcon
                          className={classNames(classes.favoriteIcon, {
                            [classes.favoriteRegIcon]: !isFavorite
                          })}
                        />
                      )}
                    </IconButton>
                  </Tooltip>
                </Fade>
              </Grid>
            </Grid>
          }
        />
      </ListItem>
    </NavLink>
  )
}

const RedirectMenu = props => {
  const { classes, name, icon, fullLink, link, newTab, admin, divider } = props
  return (
    <a
      href={fullLink || link}
      title={name}
      target={newTab ? '_blank' : '_top'}
      className={classes.menuLink}
    >
      <ListItem divider={divider} button className={classes.listItem}>
        <ListItemIcon
          classes={{
            root: classes.listItemIcon
          }}
        >
          <Icon
            className={classNames({
              [classes.icon]: true,
              [classes.adminTextColor]: admin === true
            })}
          >
            {icon}
          </Icon>
        </ListItemIcon>
        <ListItemText
          classes={{
            root: classes.listItemText
          }}
          primaryTypographyProps={{
            variant: 'body2',
            classes: {
              root: classNames({
                [classes.listTextPrimaryRoot]: true,
                [classes.adminTextColor]: admin === true
              })
            }
          }}
          primary={
            <>
              <Typography variant="body2">
                {name}
                <RxOpenInNewWindowIcon className={classes.newTabIcon} />
              </Typography>
            </>
          }
        />
      </ListItem>
    </a>
  )
}

const drawerMenu = props => {
  const {
    classes,
    menus = [],
    auth,
    favoriteMenu = [],
    onClickFavoriteIcon
  } = props
  return (
    <div>
      <div className={classes.toolbar}>
        <Hidden mdUp>
          <div className={classes.toolbarLogoArea}>
            <a href={config.homePath}>
              <img
                className={classes.logoImg}
                src={LogoImg}
                alt="logo"
                title="logo"
              />
            </a>
          </div>
        </Hidden>
      </div>
      <Divider />
      {isArray(favoriteMenu) &&
        favoriteMenu.length > 0 &&
        favoriteMenu.filter(link => {
          const menuList = [].concat(
            ...menus.map(data => [...data.list.map(list => list?.link)])
          )
          return menuList.indexOf(link) !== -1
        }).length > 0 && (
          <List
            subheader={
              <ListSubheader disableSticky className={classes.listSubheader}>
                즐겨찾기
              </ListSubheader>
            }
          >
            {favoriteMenu.map((favoriteMenuLink, index) => {
              const menuList = [].concat(...menus.map(data => data.list))
              const menuData = menuList.find(
                data => data?.link === favoriteMenuLink
              )
              if (!menuData) return null
              const divider = favoriteMenu.length - 1 === index
              return (
                <LocalMenu
                  {...props}
                  {...menuData}
                  key={`favorite-${favoriteMenuLink}`}
                  divider={divider}
                  isFavorite
                  onClickFavoriteIcon={onClickFavoriteIcon}
                />
              )
            })}
          </List>
        )}
      {menus.map((headerMenu, index) => {
        const { admin = false } = headerMenu
        return (
          <List
            key={`headerMenu-${index}-${headerMenu?.headerTitle}`}
            subheader={
              <ListSubheader disableSticky className={classes.listSubheader}>
                {headerMenu?.headerTitle}
              </ListSubheader>
            }
          >
            {headerMenu.list.map((menu, index) => {
              const { appLayoutOnly = false, hide = false } = menu || {}
              if (hide === true) return null
              const divider = index === headerMenu.list.length - 1
              const isFavorite = favoriteMenu.find(
                favoriteMenuLink => favoriteMenuLink === menu.link
              )
              menu.link = menu.link.replace(/%%accountId%%/, auth?.accountId)
              if (menu.authOnly === true && !auth) return null
              if (appLayoutOnly === true) return null
              return menu.newTab !== true ? (
                <LocalMenu
                  key={index}
                  divider={divider}
                  {...props}
                  admin={admin}
                  {...menu}
                  isFavorite={isFavorite}
                  onClickFavoriteIcon={onClickFavoriteIcon}
                />
              ) : (
                <RedirectMenu
                  key={index}
                  divider={divider}
                  {...props}
                  admin={admin}
                  {...menu}
                />
              )
            })}
          </List>
        )
      })}
    </div>
  )
}
export default withStyles(styles, { withTheme: true })(drawerMenu)
